import { Box, Stack, Typography } from '@dtx-company/design-system/src'
import Image from 'next/image'
import { FC } from 'react'
import { useScreenSizeBreakpoints } from '../../../../shared/common/src/hooks/useScreenSizeBreakpoints'

const BADGES = [
  { label: 'CCPA', iconSrc: '/icons/compliance/CCPA-lock.svg' },
  { label: 'GDPR', iconSrc: '/icons/compliance/GDPR-lock.svg' },
  { label: 'SOC2', iconSrc: '/icons/compliance/SOC2-badge.svg' },
  { label: 'SSO', iconSrc: '/icons/compliance/SSO-lock.svg' }
] as const

export const ComplianceBadgesGrid: FC = () => {
  const { isMobile } = useScreenSizeBreakpoints()
  const iconSize = isMobile ? 22 : 32
  return (
    <Box
      aria-label="Compliance and security"
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, max-content)',
        gap: { xs: 4, md: 8, lg: 5 },
        alignItems: 'center',
        mr: { lg: 12, xl: 16 },
        ml: { lg: 4 }
      }}
    >
      {BADGES.map(({ label, iconSrc }) => (
        <Stack key={label} direction="row" alignItems="center" gap={1} sx={{ color: '#F5F5F5' }}>
          <Image
            src={iconSrc}
            alt=""
            width={iconSize}
            height={iconSize}
            aria-hidden
            style={{ objectFit: 'contain', flexShrink: 0, display: 'block' }}
          />
          <Typography variant="bodySmall" component="span">
            {label}
          </Typography>
        </Stack>
      ))}
    </Box>
  )
}
